import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ClockIcon, MapPinIcon } from 'lucide-react';
import { events } from '../../data/site';
export function Agenda() {
  return <section id="agenda" className="scroll-mt-24 bg-creme py-20 md:py-24" data-id="element-103" data-mp="sv066bzqpzs9">
      <div className="mx-auto max-w-7xl px-6" data-id="element-104" data-mp="ssvvnb7c62j0">
        <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-105" data-mp="osls0570no7b">
          <div data-id="element-106" data-mp="jv3ee1i20ksz">
            <h2 className="font-display text-3xl font-bold text-nuit sm:text-4xl" data-id="element-107" data-mp="jutw70393hxu">
              Prochains rendez-vous
            </h2>
            <p className="mt-3 max-w-xl text-nuit/70" data-id="element-108" data-mp="eu5yxwofi4v6">
              Toutes nos soirées sont ouvertes au public, adhérent ou non. Entrée libre pour les
              lectures, participation au chapeau pour les concerts.
            </p>
          </div>
          <Link to="/evenements/agenda" className="inline-flex items-center gap-2 text-sm font-semibold text-braise transition-colors duration-150 ease-out hover:text-passion" data-id="element-109" data-mp="24ax8r30i4i7y">
            Tout l’agenda
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-110" data-mp="3mqhv1n52621x" />
          </Link>
        </div>

        <ul className="mt-10 border-t border-nuit/10" data-id="element-111" data-mp="3rsqnmie0r23i">
          {events.map(event => <li key={event.id} data-id="element-112" data-mp="3dsz3s10tmrhl">
              <Link to="/evenements/agenda" className="group grid items-center gap-x-6 gap-y-2 border-b border-nuit/10 py-6 transition-colors duration-150 ease-out hover:bg-grege/60 sm:grid-cols-[auto_1fr_auto] sm:px-3" data-id="element-113" data-mp="3dtr1bhdzazai">
                <div className="flex h-16 w-16 shrink-0 flex-col items-center justify-center rounded-2xl text-white" style={{
              backgroundColor: event.color
            }} data-id="element-114" data-mp="ebres6txw5dg">
                  <span className="font-display text-xl font-bold leading-none" data-id="element-115" data-mp="4kmwax5222dv">{event.day}</span>
                  <span className="text-[11px] uppercase" data-id="element-116" data-mp="saqz52af5y3t">{event.month}</span>
                </div>

                <div data-id="element-117" data-mp="x4238vnuk0s1">
                  <p className="text-xs font-semibold uppercase tracking-[0.14em]" style={{
                color: event.color
              }} data-id="element-118" data-mp="16yr212u7fh0s">
                    {event.category}
                  </p>
                  <h3 className="mt-1 font-display text-xl font-semibold text-nuit" data-id="element-119" data-mp="xx9ptvjx3zhd">
                    {event.title}
                  </h3>
                  <p className="mt-1 text-sm text-nuit/60" data-id="element-120" data-mp="t12hxx7yodws">{event.subtitle}</p>
                </div>

                <div className="flex flex-wrap items-center gap-x-5 gap-y-1 text-sm text-nuit/70 sm:justify-end" data-id="element-121" data-mp="o1zn15lp3o2j">
                  <span className="inline-flex items-center gap-1.5" data-id="element-122" data-mp="j7bzpa2fgzpj">
                    <ClockIcon className="h-4 w-4 text-nuit/40" aria-hidden="true" data-id="element-123" data-mp="f7tc26j82aj0" />
                    {event.time}
                  </span>
                  <span className="inline-flex items-center gap-1.5" data-id="element-124" data-mp="5945vb0oueil">
                    <MapPinIcon className="h-4 w-4 text-nuit/40" aria-hidden="true" data-id="element-125" data-mp="5bhvv5gih0ja" />
                    {event.place}
                  </span>
                  <ArrowRightIcon className="hidden h-4 w-4 text-braise transition-transform duration-200 ease-out group-hover:translate-x-1 sm:block" aria-hidden="true" data-id="element-126" data-mp="3mcjfdlnxwkvj" />
                </div>
              </Link>
            </li>)}
        </ul>

        <p className="mt-8 text-sm text-nuit/70" data-id="element-127" data-mp="52lbwyhlii48">
          <span className="font-semibold text-nuit" data-id="element-128" data-mp="51a8izs2bcdn">Ciné-club :</span> tous les 1ers mardis du mois
          à 20h30, Salle de la Concorde à Valmont.
        </p>
      </div>
    </section>;
}